module.exports = __webpack_public_path__ + "img/富文本.d02c233d.jpg";